const ANDROID_OBJ = 'androidObj';
const NATIVE_SUPPORT_KEY = 'thirdPartyNativeSupport';
const TYPE_FUNCTION = 'function';
const TYPE_STRING = 'string';
const nativeKeyMap = {
	CLOSE_WEBVIEW: 146,
	OPEN_DEEPLINK: 144,
};
const _setAndroidClass = () => {
	if (!_isAFunction(window.androidObj)) {
		window.androidObj = function AndroidClass() {};
		sessionStorage.setItem(ANDROID_OBJ, window.androidObj);
	}
};
const renderParams = (params) => (typeof params === TYPE_STRING ? params : JSON.stringify(params));
const _isAFunction = (item) => typeof item === TYPE_FUNCTION;
const _isNativeActivated = () =>
	_isAFunction(window.androidObj) && window.androidObj.hasOwnProperty(NATIVE_SUPPORT_KEY);

export const _init = (legacy = false) => {
	// eslint-disable-next-line no-unused-vars
	return new Promise((resolve, _) => {
		_setAndroidClass();
		const checkNativeSupport = setInterval(() => {
			if (_isNativeActivated()) {
				console.log('Native check activated');
				clearInterval(checkNativeSupport);
				resolve(true);
			}
		}, 100);
	});
};
class NativeInterface {
	constructor() {
		this.nativeSupport = false;
		// Native support check
		if (_isNativeActivated()) {
			this.nativeSupport = true;
		} else {
			return;
		}
	}
	/**
	 * @function _openDeeplink
	 * @description Opens deeplink
	 */
	_openDeeplink(params) {
		if (!this.nativeSupport) return;
		window.sendDeepLinkToJs = (res) => {
			console.log('Deeplink', res);
		};
		const payload = renderParams({ key: nativeKeyMap.OPEN_DEEPLINK, deeplink: 'postpe://dynamic?key=home' + params });
		window.androidObj.thirdPartyNativeSupport(payload);
	}
	/**
	 * @function _callBackClosed
	 * @description closes the webview
	 */
	_callBackClosed() {
		return new Promise((resolve, reject) => {
			window.callBackClosed = (data) => {
				if (data) {
					resolve(data);
				} else {
					reject('Invalid data');
				}
			};
			window.callBackFailure = (err) => {
				reject('Native call back failed', err);
			};
			if (!this.nativeSupport) {
				reject();
				return;
			}
			const payload = renderParams({ key: nativeKeyMap.CLOSE_WEBVIEW });
			window.androidObj.thirdPartyNativeSupport(payload);
		});
	}
}
export const jsBridge = {
	closeWebview: () => new NativeInterface()._callBackClosed(), //closes WebVIew

	openDeeplink: (params = []) => new NativeInterface()._openDeeplink(params), ///Opens bharatpePrd
};
